export default __webpack_public_path__ + "static/media/jordan_1.45535689.png";